import * as z from 'zod';

export const formShcema = z.object({
    numberphone: z
        .string()
        .min(11, 'لطفا شماره  خود را وارد نمایید !')
        .min(11, 'لطفا شماره تماس خود را کامل وارد نمایید!')
        .max(11, 'شماره تماس باید دقیقا 11 رقم باشد'),
    verifiercode: z
        .string({
            required_error: 'لطفا کد خود را کامل وارد نمایید !',
        })
        .optional(),
    redirect: z.string().default('/').optional(),
});

export const userSchema = z.object({
    firstName: z.string().min(1, 'نام الزامی است'),
    lastName: z.string().min(1, 'نام خانوادگی الزامی است'),
    national_code: z
        .string()
        .min(1, 'کد ملی الزامی است !')
        .min(10, 'لطفا کد ملی خود را کامل وارد نمایید')
        .max(10, 'کد ملی باید حداکثر 10 رقم باشد !'),
    state: z
        .string({
            required_error: 'لطفاً استان را انتخاب کنید',
        })
        .min(1, 'لطفاً استان را انتخاب کنید'),
    city: z
        .string({
            required_error: 'لطفاً شهر را انتخاب کنید',
        })
        .min(1, 'لطفاً شهر را انتخاب کنید'),
});

export const schema_add_user = z.object({
    name: z.string({
        required_error: 'نام و نام خانوادگی وارد نمایید !',
    }),
    national_code: z.string().min(10, 'کد ملی را کامل وارد نمایید!'),
    mobile: z
        .string()
        .regex(/^09\d{9}$/, 'شماره تماس وارد شده معتبر نیست')
        .min(11, 'لطفا شماره تماس خود را کامل وارد نمایید'),
});

export const baseFormSchema = z.object({
    firstName: z.string().min(2, 'نام الزامی است !'),
    lastName: z.string().min(2, 'نام خانوادگی را کامل وارد نمایید'),
    national_code: z.string().length(10, 'کد ملی باید 10 رقم باشد'),
    mobile: z.string().optional(),
    id: z.union([z.string(), z.number()]).optional(),
    otherHasNoPhone: z.boolean(),
});

export const withSelfFormSchema = baseFormSchema.extend({
    firstNamePatient: z.string().min(2, 'نام الزامی است !'),
    lastNamePatient: z.string().min(2, 'نام خانوادگی را کامل وارد نمایید'),
    main_national_code: z
        .string()
        .length(10, 'کد ملی باید 10 رقم باشد')
        .optional(),
    main_mobile: z
        .string()
        .regex(/^09\d{9}$/, 'شماره تماس وارد شده معتبر نیست')
        .min(11, 'لطفا شماره تماس خود را کامل وارد نمایید')
        .optional(),
    city_id: z
        .string({
            required_error: 'استان و شهر انتخاب نمایید !',
        })
        .min(3, 'شهر انتخاب نمایید !'),
});

export const withOutSelfFromSchema = baseFormSchema
    .extend({})
    .superRefine(({ otherHasNoPhone, mobile }, ctx) => {
        if (!otherHasNoPhone) {
            if (!mobile || mobile.length !== 11) {
                ctx.addIssue({
                    code: 'custom',
                    path: ['mobile'],
                    message: 'لطفا شماره تماس خود را کامل وارد نمایید',
                });
            } else if (!/^09\d{9}$/.test(mobile)) {
                ctx.addIssue({
                    code: 'custom',
                    path: ['mobile'],
                    message: 'شماره تماس وارد شده معتبر نمی باشد',
                });
            }
        }
    });

export const FeedbacksFormSchema = z.object({
    reason: z.string(),
    description: z
        .string()
        .min(1, 'لطفاً نظر خود را درباره‌ی دکتر، منشی و محیط مطب را بنویسید'),
    main_score: z
        .number({
            required_error: 'امتیاز خود را وارد نمایید !',
            invalid_type_error: 'امتیاز معتبر وارد کنید!',
        })
        .min(1, 'امتیاز خود را وارد نمایید !'),

    scores: z
        .array(
            z.object({
                rate_id: z.number(),
                value: z.number().min(1, 'لطفاً به همه موارد امتیاز بدهید'),
            }),
        )
        .min(1, 'لطفاً به همه موارد امتیاز بدهید'),

    waiting_time: z
        .string({
            required_error: 'لطفا زمان انتظارتان را در مطب مشخص نمایید',
            invalid_type_error: 'لطفا زمان انتظارتان را در مطب مشخص نمایید',
        })
        .min(1, 'لطفا زمان انتظارتان را در مطب مشخص نمایید'),
    anonymous: z.boolean().optional(),
    recommend: z.number().optional(),
});

export const JoinFormSchema = z
    .object({
        first_name: z.string().min(2, 'نام را وارد کنید'),
        last_name: z.string().min(2, 'نام خانوادگی را وارد کنید'),
        expert_first_name: z.string().min(2, 'نام کارشناس را وارد کنید'),
        expert_last_name: z
            .string()
            .min(2, 'نام خانوادگی کارشناس را وارد کنید'),
        mobile: z.string().regex(/^09\d{9}$/, 'شماره تماس معتبر نیست'),
        expert_mobile: z
            .string()
            .regex(/^09\d{9}$/, 'شماره تماس کارشناس معتبر نیست'),
        global_mobile: z
            .string()
            .regex(/^09\d{9}$/, 'شماره مجازی معتبر نیست')
            .optional(),
        national_code: z.string().length(10, 'کد ملی باید ۱۰ رقم باشد'),
        instagram_id: z.string().optional(),
        medical_system_code: z.string().min(1, 'کد نظام پزشکی الزامی است'),
        turn_description: z.string().min(1, 'توضیحات نوبت را وارد کنید'),
        specialty: z.string().min(1, 'تخصص خود را انتخاب کنید'),
        hospitals: z.string().optional(),
        // hospitals: z.array(z.string()).optional(),
        insurance: z.array(z.string()).min(1, 'حداقل یک بیمه را انتخاب کنید'),
        patient_description: z.string().optional(),
        description: z.string().optional(),
        tourism: z.boolean(),
        showMorningTurnInputs: z.boolean(),
        showNightTurnInputs: z.boolean(),
        morinings_turn: z.array(z.string()).optional(),
        morning_from: z.string().optional(),
        morning_to: z.string().optional(),
        night_turn: z.array(z.string()).optional(),
        night_from: z.string().optional(),
        night_to: z.string().optional(),

        city: z.array(z.string()).min(1, 'حداقل یک شهر را انتخاب کنید'),

        card_file_1: z
            .any()
            .refine(
                (f) => f instanceof File,
                ' تصویر مدرک نظام پزشکی الزامی است',
            ),
        card_file_2: z
            .any()
            .refine((f) => f instanceof File, 'تصویر پروفایل الزامی است'),
        clinic_addresses: z
            .array(
                z.object({
                    title: z.string(),
                    address: z.string().min(1, 'آدرس مرکز الزامی است'),
                }),
            )
            .min(1, 'حداقل یک مرکز را انتخاب و آدرس آن را وارد نمایید'),
    })
    .superRefine((data, ctx) => {
        if (data.showMorningTurnInputs) {
            if (!data.morinings_turn || data.morinings_turn.length < 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'حداقل یک روز برای نوبت صبح انتخاب کنید',
                    path: ['morinings_turn'],
                });
            }

            if (!data.morning_from) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'ساعت شروع نوبت دهی صبح را وارد کنید',
                    path: ['morning_from'],
                });
            }

            if (!data.morning_to) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'ساعت پایان نوبت دهی صبح را وارد کنید',
                    path: ['morning_to'],
                });
            }
        }

        if (data.showNightTurnInputs) {
            if (!data.night_turn || data.night_turn.length < 1) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'حداقل یک روز برای نوبت عصر انتخاب کنید',
                    path: ['night_turn'],
                });
            }

            if (!data.night_from) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'ساعت شروع نوبت دهی عصر را وارد کنید',
                    path: ['night_from'],
                });
            }

            if (!data.night_to) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'ساعت پایان نوبت دهی عصر را وارد کنید',
                    path: ['night_to'],
                });
            }
        }
    });

export type FormDataPatient = z.infer<typeof baseFormSchema>;
export type withSelfFormData = z.infer<typeof withSelfFormSchema>;
export type otherFormData = z.infer<typeof withOutSelfFromSchema>;
